
import { defineComponent } from 'vue';
import Landing from '@/components/Landing.vue'; // @ is an alias to /src
import Services from '@/components/Services.vue'; // @ is an alias to /src
import RecentProjects from '@/components/RecentProjects.vue'; // @ is an alias to /src
import NiceWords from '@/components/NiceWords.vue'; // @ is an alias to /src

export default defineComponent({
  name: 'Home',
  components: {
    Landing,
    Services,
    RecentProjects,
    NiceWords
  },
  
  mounted(){
    window.scrollTo(0, 0);
  }
});
